import React from 'react';
import Slide from '@material-ui/core/Slide';

/*
export default function Transition(props) {
	return <Slide direction="up" {...props} />;
}
*/

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default Transition;
